/* global axios */
import ApiClient from './ApiClient';

class SourceActionsAPI extends ApiClient {
  constructor() {
    super('conversations', { accountScoped: true });
  }

  complaint(conversationId, { reason, comment }) {
    return axios.post(
      `${this.url}/${conversationId}/source_actions/complaint`,
      { reason, comment }
    );
  }

  editReply(conversationId, content) {
    return axios.patch(`${this.url}/${conversationId}/source_actions/reply`, {
      content,
    });
  }
}

export default new SourceActionsAPI();
